import React from "react";
import { HintView } from "lib/components/index";

const Hint = () => (
  <HintView.Hint>
    <h3>{I18n.t("papp.accommodation.AccommodationSchedulerView.hintHeader")}</h3>
    <p>{I18n.t("papp.accommodation.AccommodationSchedulerView.hintContent")}</p>
  </HintView.Hint>
);

export default Hint;



// WEBPACK FOOTER //
// ./src/modules/accommodation/AccommodationSchedulerView/AccommodationSchedulerHint.jsx